const STATUS_PRESENTATIONS = Object.freeze({
    requested: {label: "Ожидает решения", tone: "warning", known: true},
    approved: {label: "Одобрен", tone: "warning", known: true},
    rejected: {label: "Отклонен", tone: "danger", known: true},
    posted: {label: "Проведен", tone: "success", known: true},
    failed: {label: "Ошибка проведения", tone: "danger", known: true},
    cancelled: {label: "Отменен", tone: "neutral", known: true},
});

const UNKNOWN_STATUS = Object.freeze({
    label: "Неизвестный статус",
    tone: "neutral",
    known: false,
});

export const REFUND_ACTIONS = Object.freeze({
    approve: {label: "Одобрить", capability: "refunds.approve"},
    reject: {label: "Отклонить", capability: "refunds.reject"},
    cancel: {label: "Отменить запрос", capability: "refunds.cancel"},
});

export const getRefundStatusPresentation = (status) =>
    STATUS_PRESENTATIONS[status] || UNKNOWN_STATUS;

export const getRefundActionPresentation = (action) =>
    REFUND_ACTIONS[action] || null;

export const actionsForRefund = (request, hasAction) => {
    const status = getRefundStatusPresentation(request?.status);
    if (!status.known || request.status !== "requested" || typeof hasAction !== "function") {
        return [];
    }
    return ["approve", "reject", "cancel"].filter((action) =>
        hasAction(REFUND_ACTIONS[action].capability),
    );
};

export const hasPostedRefund = (request) =>
    typeof request?.posted_refund_id === "string" && Boolean(request.posted_refund_id);
